import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TextAreaField, TextField } from '../../legacy-form-fields'
import { SwiftlaneConnectionFormValues } from './swiftlane.schema'

export const SwiftlaneFields = () => {
  const { t } = useTranslation(['organisation'])
  const authToken = useController<SwiftlaneConnectionFormValues>({ name: 'authToken' })
  const accountName = useController<SwiftlaneConnectionFormValues>({
    name: 'swiftlaneAccountName',
  })
  const config = useController<SwiftlaneConnectionFormValues>({ name: 'config' })

  return (
    <div className="integration-configuration">
      <TextField
        errorLabel={authToken.fieldState.error?.message}
        isError={Boolean(authToken.fieldState.error)}
        label={t('organisation:places.integrations.swiftlane.authTokenField.label')}
        name={authToken.field.name}
        placeholder={t('organisation:places.integrations.swiftlane.authTokenField.placeholder')}
        type="password"
        value={authToken.field.value ?? ''}
        onBlur={authToken.field.onBlur}
        onChange={authToken.field.onChange}
      />
      <TextField
        errorLabel={accountName.fieldState.error?.message}
        isError={Boolean(accountName.fieldState.error)}
        label={t('organisation:places.integrations.swiftlane.accountNameField.label')}
        name={accountName.field.name}
        placeholder={t('organisation:places.integrations.swiftlane.accountNameField.placeholder')}
        value={accountName.field.value ?? ''}
        onBlur={accountName.field.onBlur}
        onChange={accountName.field.onChange}
      />
      <TextAreaField
        errorLabel={config.fieldState.error?.message}
        isError={Boolean(config.fieldState.error)}
        label={t('organisation:places.integrations.swiftlane.configField.label')}
        name={config.field.name}
        placeholder={t('organisation:places.integrations.swiftlane.configField.placeholder')}
        rows={8}
        value={config.field.value ?? ''}
        onBlur={config.field.onBlur}
        onChange={config.field.onChange}
      />
    </div>
  )
}
